export type RevealCenterSpace = 'world';

/**
 * PlayCanvas's shipped GsplatRevealRadial computes distance from the render-stage splat
 * center and its public examples pass world-space centers. Keeping this world-space on
 * WebGL/CPU matches the minimal reveal harness and prevents the mobile reveal wave from
 * originating outside the scene.
 */
export function revealCenterSpaceForRenderer(
  currentRenderer: number,
  rasterGpuSortRenderer: number,
): RevealCenterSpace {
  void currentRenderer;
  void rasterGpuSortRenderer;
  return 'world';
}
